export enum RatesheetSortTypes {
  NAME = 'NAME',
  USED_IN = 'USED_IN',
  CREATION_DATE = 'CREATION_DATE',
  CREATED_BY = 'CREATED_BY',
}
